import axiosInstance from "../config/axiosConfig";

export class BaseService {
  async get(url: string, headers?: Record<string, string>) {
    try {
      const response = await axiosInstance.get(url, { headers });
      return response.data;
    } catch (error: any) {
      return this.handleError(error);
    }
  }

  async post(url: string, data: any, headers?: Record<string, string>) {
    try {
      const response = await axiosInstance.post(url, data, { headers });
      return response.data;
    } catch (error: any) {
      return this.handleError(error);
    }
  }
  async put(url: string, data: any, headers?: Record<string, string>) {
    try {
      const response = await axiosInstance.put(url, data, { headers });
      return response.data;
    } catch (error: any) {
      return this.handleError(error);
    }
  }

  handleError(error: any) {
    if (error.response) {
      const message =
        error.response.data?.message ||
        "An error has occurred. Please try again later.";
      const data = error.response.data || null;
      return { error: message, data };
    } else {
      return { error: "A network error occurred. Please try again later." };
    }
  }
}
